import axios from "axios";
import consts from "../consts";
import { initialize } from "redux-form";
import { setErroAPI, setSuccess } from "../common/toast/toast";

export function setModoTela(modo, registro = {}) {
    return {
        type: "GESTOR_CONCESSIONARIA_MODO_TELA",
        payload: {
            modo: modo,
            registro: registro,
        },
    };
}

export function setAguardando(aguardando) {
    return {
        type: "GESTOR_CONCESSIONARIA_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export function initForm(registro = {}) {
    return [initialize("gestorConcessionariaForm", registro)];
}

export function vincularGestorConcessionariaNasUnidades({ registro, callback }) {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        if (!usuarioLogado) return {};
        const registroFormatado = { ...registro };
        try {
            if (
                !window.confirm(
                    `Deseja realmente ${
                        registro.id_gestor_concessionaria_energia || registro.id_gestor_concessionaria_agua ? "vincular" : "desvincular"
                    } das unidades listadas na tabela?`
                )
            ) {
                return {};
            }
            dispatch(setAguardando(true));
            registroFormatado.id_usuario_alteracao = usuarioLogado.id;
            await axios.put(`${consts.API_URL}/gestor-concessionaria/vincular-unidades`, registroFormatado);
            setSuccess("Operação Realizada com sucesso.");
            if (callback) callback();
        } catch (erro) {
            console.log(erro);
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvar(registro) {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        if (!usuarioLogado) return {};
        const registroFormatado = { ...registro, telefone: String(registro.telefone).replace(/\D/g, "") };
        try {
            dispatch(setAguardando(true));
            if (!registro.id) {
                registroFormatado.id_usuario_inclusao = usuarioLogado.id;
                await axios.post(`${consts.API_URL}/gestor-concessionaria`, registroFormatado);
            } else {
                registroFormatado.id_usuario_alteracao = usuarioLogado.id;
                await axios.put(`${consts.API_URL}/gestor-concessionaria`, registroFormatado);
            }
            setSuccess("Operação Realizada com sucesso.");
            dispatch(getLista());
            dispatch(setModoTela("lista"));
        } catch (erro) {
            setErroAPI(erro);
            dispatch(
                initForm({
                    ...registro,
                })
            );
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async (dispatch, getState) => {
        try {
            if (window.confirm("Deseja realmente excluir?")) {
                dispatch(setAguardando(true));
                await axios.delete(`${consts.API_URL}/gestor-concessionaria?id=${registro.id}`);
            }
            setSuccess("Operação Realizada com sucesso.");
            dispatch(getLista());
            dispatch(setModoTela("lista"));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getLista() {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            const resp = await axios.get(`${consts.API_URL}/gestor-concessionaria`);
            dispatch({
                type: "GESTOR_CONCESSIONARIA_LISTADO",
                payload: resp,
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getGestorConcessionariaSelect() {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            const resp = await axios.get(`${consts.API_URL}/gestor-concessionaria/listar-select`);
            dispatch({
                type: "GESTOR_CONCESSIONARIA_SELECT_LISTADO",
                payload: resp,
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
